import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { CategorySelectFormikField } from '../../../Category'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import {
  SelectDropdownListHeader,
  SelectDropdownListSearchInput,
  useInitiallyOpenSelect,
} from '../../../Select'
import {
  REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD,
  REQUEST_EDIT_CATEGORY_FORM_INITIAL_VALUES,
} from '../RequestEditCategoryModal.constants'

import { showCategorySearchHeader } from './RequestEditCategoryModalFields.utils'

function RequestEditCategoryModalFields({ actionTypes }) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const selectStatesRef = useInitiallyOpenSelect()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: REQUEST_EDIT_CATEGORY_FORM_INITIAL_VALUES,
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: errors[REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD],
          options: actionTypes,
        }}
      >
        <CategorySelectFormikField
          Field={FieldStackedLabel}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t(
                  'Request.EditCategoryFormCategoryFieldPlaceholderKey'
                ),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          fieldComponentProps={{
            label: t('Request.EditCategoryFormCategoryFieldLabelKey'),
          }}
          listProps={{
            Header: SelectDropdownListHeader,
            headerProps: { Search: SelectDropdownListSearchInput },
            showHeader: showCategorySearchHeader,
          }}
          name={REQUEST_EDIT_CATEGORY_FORM_CATEGORY_FIELD}
          selectStatesRef={selectStatesRef}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default RequestEditCategoryModalFields
